import { useState, useEffect } from "react";
import { get } from "../../../api";
import { COUNTRY_CODES_URL } from "../../../api/apiRoutes";

export const useCountryCodes = () => {
  const [countryCodes, setCountryCodes] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const { result, isError } = await get(COUNTRY_CODES_URL);
        if (!isError && Array.isArray(result) && result.length > 0) {
          const sorted = ["PL", ...result.filter((c: string) => c !== "PL").sort()];
          setCountryCodes(sorted);
          setHasError(false);
        } else {
          setHasError(true);
        }
      } catch {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCountryCodes();
  }, []);

  return { countryCodes, isLoading, hasError };
};
